import nfetch from "@/utils/events/nfetch";

import { IServiceAnexo } from "./base/iServiceAnexo";

export default class ProdutoLoteAnexoService extends IServiceAnexo {
    constructor() {
        super("ProdutoLoteAnexo");
    }

    public insertLaudoTecnico(id: number, descricao: string, laudoTecnico: boolean, file: File): Promise<Response> {
        const data = new FormData();
        const ext = file.getExtension();
        data.append("file", file, file.name);
        return nfetch(
            `/${this.controllerName}/InsertLaudoTecnico?id=${id}&descricao=${descricao}&extensao=${ext}&laudoTecnico=${laudoTecnico}`,
            {
                method: "post",
                credentials: "same-origin",
                body: data,
            },
        );
    }
}
